module.exports = __webpack_public_path__ + "img/levelbackground.36a24783.png";